import Bold from '../atoms/text/bold';
import FlavourConfig from '../../../shared/config/flavours';
import Focal from '../atoms/text/focal';
import Focus from '../../../shared/types/enums/focus';
import Languages from '@shared/types/enums/languages';
import LanguageContext from '../../../shared/components/utils/context/languageContext';
import LanguageInfo from '../atoms/text/languageInfo';
import LanguagesContainer from '../atoms/container/languagesContainer';
import LanguagesList from '../sections/list/languagesList/languagesList';
import MainContainer from '../atoms/container/mainContainer';
import TranslationManager from '../../../shared/assets/locale/translationsManager';
import useBackKeyboard from '../../../shared/components/utils/hooks/useBackKeyboard';
import useTranslationRefresh from '../../../shared/components/utils/hooks/useTranslationRefresh';
import useKeyboard from '../../../shared/components/utils/hooks/useKeyboard';
import useMenu from '../../../shared/components/utils/hooks/useMenu';
import { popRoute } from '../../../shared/store/thunks/route.thunk';
import { useAppDispatch, useAppSelector } from '../../../shared/store/hooks';
import { useEffect, useRef, useState } from 'react';
import {
  setFocus,
  focusSelector,
} from '../../../shared/store/slices/focus.slice';

const LITERALS = 'PAGES.SETTINGS.LANGUAGES';

function TLanguages() {
  const dispatch = useAppDispatch();
  const { focus } = useAppSelector(focusSelector);

  const currentLanguage = useRef(
    TranslationManager.currentLanguage as Languages
  );
  const focusRef = useRef(focus);

  const menuFocused = focus === Focus.MENU;
  focusRef.current = focus;

  const [text, setText] = useState({
    action: '',
    description: '',
    selection: '',
    title: '',
  });

  // Pop route action

  const returnAction = () => {
    dispatch(popRoute());
  };

  // Language selection actions

  const displayLanguage = (language: Languages) => {
    TranslationManager.setLanguage(language);
    setText({
      action: TranslationManager.get(
        `${LITERALS}.ACTION`,
        FlavourConfig.appTitle
      ),
      description: TranslationManager.get(`${LITERALS}.SELECT_LANGUAGE`),
      selection: TranslationManager.get(
        `${LITERALS}.LANGUAGE_SELECTED`,
        TranslationManager.get(
          `MISC.LANGUAGES.TRANSLATED.${currentLanguage.current}`
        )
      ),
      title: TranslationManager.get(`${LITERALS}.CONFIG`),
    });
  };

  const setLanguage = () => {
    currentLanguage.current = TranslationManager.currentLanguage;
    returnAction();
  };

  // Keyboard hooks

  useBackKeyboard();

  useKeyboard({
    focus: Focus.LANGUAGES,
    keyDownHandler: (key) => {
      if (key === 'SELECT') {
        setLanguage();
      }
    },
  });

  // Menu hook

  useMenu(null, true);

  // Translation hook

  useTranslationRefresh();

  // Effect hooks

  useEffect(() => {
    displayLanguage(currentLanguage.current);
    dispatch(setFocus(Focus.LANGUAGES));
    return () => {
      TranslationManager.setLanguage(currentLanguage.current);
    };
  }, []);

  useEffect(() => {
    if (focus !== Focus.LANGUAGES) {
      TranslationManager.setLanguage(currentLanguage.current);
    }
  }, [focus]);

  return (
    <MainContainer id={'languageContainer'}>
      <LanguagesContainer
        animation={menuFocused ? 'main-content-out' : 'main-content-in'}
        force={true}
      >
        <LanguageContext.Provider value={{ displayLanguage, setLanguage }}>
          <LanguagesList languages={FlavourConfig.languages} />
        </LanguageContext.Provider>
        <LanguageInfo id={'textLanguageInfo'}>
          <Bold id={'titleLanguageInfo'}>{text.title}</Bold>
          <br></br>
          <Focal id={'selectionLanguageInfo'}>{text.selection}</Focal>
          <br></br>
          <br></br>
          {text.description}
          <br></br>
          <br></br>
          {text.action}
        </LanguageInfo>
      </LanguagesContainer>
    </MainContainer>
  );
}

export default TLanguages;
